module.exports = core_library;


//////////////////
// WEBPACK FOOTER
// external "core_library"
// module id = 12
// module chunks = 8 9 10